"use client";

import posthogRaw, { type PostHog } from "posthog-js";
import { PostHogProvider as PostHogProviderRaw } from "posthog-js/react";
import type { ReactNode } from "react";
import { isInIframe } from "../is-iframe";
import { keys } from "../keys";

const trackingDisabled = isInIframe();

export const analytics = (
	trackingDisabled
		? posthogRaw
		: posthogRaw.init(keys().NEXT_PUBLIC_POSTHOG_KEY, {
				api_host: "/ingest",
				ui_host: keys().NEXT_PUBLIC_POSTHOG_HOST,
				person_profiles: "identified_only",
				capture_pageview: false,
				capture_pageleave: true,
			})
) as PostHog;

type PostHogProviderProps = {
	readonly children: ReactNode;
};

export const PostHogProvider = ({
	children,
}: Omit<PostHogProviderProps, "client">) => {
	if (trackingDisabled) {
		return <>{children}</>;
	}

	return <PostHogProviderRaw client={analytics}>{children}</PostHogProviderRaw>;
};
